<template>
    <div>
        <h3>{{ $t('edit_payment_method') }}</h3>
        <Loading :loading="loading" :inset="true" :text="$t('edit_payment_method') + '...'">
            <form @submit.prevent="editPaymentMethod()" class="relative">
                <Checkbox name="primary" :label="$t('use_as_primary_payment_method')" v-model:value="getPaymentMethod.data.primary" class="my-8"> </Checkbox>
                <FormButton type="submit" class="my-8" styling="primary flex items-center gap-3" :value="$t('edit_payment_method')" :disabled="loading">
                    <transition name="fade">
                        <FontAwesomeIcon v-show="loading" :icon="['fas', 'circle-notch']" class="animate-spin text-white transition-all ease-in-out duration-300"></FontAwesomeIcon>
                    </transition>
                </FormButton>
            </form>
        </Loading>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('payment_methods', ['getPaymentMethod'])
    },

    data: () => ({
        loading: false
    }),

    methods: {
        editPaymentMethod() {
            this.loading = true;
            this.$store.dispatch('payment_methods/update', this.getPaymentMethod.data).finally((response) => {
                this.loading = false;
            });
        }
    }
};
</script>
